import { processHtmlAttributes } from "../../common/html-attributes/index.js";
import IconButton from "<ebay-icon-button>";
import FilterChip from "<ebay-filter-chip>";
import Button from "<ebay-button>";
$ const {
  class: inputClass,
  style,
  type,
  text,
  icon,
  a11yText,
  noToggleIcon,
  reverse,
  strategy,
  flip,
  fixWidth,
  borderless,
  size,
  partiallyDisabled,
  footerButton,
  priority: inputPriority,
  disabled,
  variant: inputVariant,
  item: items = [],
  label,
  prefixLabel,
  prefixId,
  split,
  collapseOnSelect,
  transparent,
  status,
  ...htmlInput
} = input;
$ var labelId = prefixId && component.getElId("label");
$ var isFormVariant = inputVariant === "form";
$ var isFilterVariant = inputVariant === "filter";
$ var variant;
$ var isOverflowVariant = inputVariant === "overflow";
$ var isButtonVariant = false;
$ var priority = null;
$ if (borderless) {
  // Force button variant for borderless
  isOverflowVariant = false;
  isFormVariant = false;
}
$ var isIconVariant = inputVariant === "icon" || isOverflowVariant;
$ tagName = Button;
$ var tagName;
$ if (isIconVariant) {
  tagName = IconButton;
} else if (isFormVariant) {
  variant = "form";
  isButtonVariant = true;
} else if (isFilterVariant) {
  tagName = FilterChip;
  variant = "menu";
} else {
  isButtonVariant = true;
  priority = inputPriority;
}
$ var separatorCount = 0;
<span ...processHtmlAttributes(htmlInput) class=["menu-button", inputClass] style=style on-expander-expand("handleExpand") on-expander-collapse("handleCollapse") onMousedown("handleMousedown")>
  <${tagName} class=[`menu-button__button`] size=size priority=priority borderless=borderless variant=variant aria-expanded="false" aria-haspopup="true" selected=(isFilterVariant && state.isSelected) transparent=(isIconVariant && transparent) aria-label=a11yText aria-labelledby=(labelId && `${prefixId} ${labelId}`) split=(isButtonVariant ? split : undefined) disabled=disabled partiallyDisabled=partiallyDisabled on-escape("handleButtonEscape") key="button">
    <if(isOverflowVariant)>
      <ebay-overflow-vertical-16-icon/>
    </if>
    <else>
      <if(label)>
        <if(prefixLabel)>
          <span class="menu-button-prefix-label">
            ${prefixLabel}
          </span>
          <${label.renderBody}/>
        </if>
        <else>
          <span id=labelId>
            <${label.renderBody}/>
          </span>
        </else>
      </if>
      <else>
        <if(icon)>
          <${icon}/>
        </if>
        <if(text)>
          <span id=labelId>
            ${text}
          </span>
        </if>
        <if(isFilterVariant && status)>
          <${status}(state.selectedCount, state.checkedItems || [])/>
        </if>
      </else>
      <if(isButtonVariant && !noToggleIcon)>
        <ebay-chevron-down-12-icon/>
      </if>
    </else>
  </>
  <ebay-menu classPrefix="menu-button" fixed=(strategy === "fixed") variant=(isFilterVariant ? "filter" : "none") type=type fixWidth=fixWidth tabindex=-1 footerButton=footerButton on-footer-button-click("emit", "footer-button-click") on-keydown("handleMenuKeydown") on-change("handleMenuChange") on-select("handleMenuSelect") key="content">
    <for|item, index| of=(items || [])>
      $ if (item.separator) {
        separatorCount++;
      }
      <@item ...item checked=component.isChecked(index - separatorCount)/>
    </for>
  </ebay-menu>
</span>